import * as React from "react";
import { fieldControlStyles } from "@/components/ui/control-styles";
import { cn } from "@/lib/utils";

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        "flex h-9 w-full rounded-full px-4 text-sm text-ink placeholder:text-muted pointer-coarse:h-11",
        fieldControlStyles,
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
